import './utente-non-riconosciuto.scss';
import React from 'react';
import {Link} from 'react-router-dom';
import {ROUTES} from '../../constant/constant';

function UtenteNonRiconosciuto() {
  return (
    <div className="UtenteNonRiconosciuto">
      <p>
        Se ti sei registrato con un altro numero <Link to={ROUTES.HOME} >Riprova</Link>
      </p>
      <div>
        <p>
          Se hai bisogno di assistenza per modificare i tuoi consensi o cancellare la tua iscrizione al servizio Wi-Fi My Lotteries scrivi a <a href="mailto:privacy@mylotteries.it">privacy@mylotteries.it</a> oppure chiama il numero <a href="tel:800 929394">800 929394</a> (ogni giorno dalle 07:00 alle 20:00)
        </p>
      </div>
    </div>
  );
}

export default UtenteNonRiconosciuto;
